// Legacy Auth0/Azure constants removed - now using Stytch
// Removed: domain, consumer_app_client_id, loan_officer_app_client_id, audience

// API Configuration - now points to monolithic backend
// When served over HTTPS in dev, use the current origin (Vite proxy) to avoid mixed content.
const rawApi = import.meta.env.VITE_API_BASE_URL;
export const api =
  typeof window !== 'undefined' &&
  window.location?.protocol === 'https:' &&
  !import.meta.env.PROD
    ? `${window.location.origin}/api/v1`
    : rawApi;
export const sentry_dsn = import.meta.env.VITE_SENTRY_DSN;

export const company_name = import.meta.env.VITE_APP_COMPANY_NAME;
export const company_tagline = import.meta.env.VITE_APP_COMPANY_TAGLINE;
export const topbar_logo = import.meta.env.VITE_APP_TOP_BAR_LOGO;
export const navbar_logo = import.meta.env.VITE_APP_NAV_BAR_LOGO;
export const chat_logo = import.meta.env.VITE_APP_CHAT_LOGO;
export const company_logo = import.meta.env.VITE_APP_COMPANY_LOGO;
export const company_logo_app = import.meta.env.VITE_APP_COMPANY_LOGO_APP;
export const onboarding_logo = import.meta.env.VITE_APP_ONBOARDING_LOGO;

export const organisation_id = import.meta.env.VITE_APP_ORGANISATION_ID;
export const company_info = import.meta.env.VITE_APP_COMPANY;
export const branch_info = import.meta.env.VITE_APP_BRANCH;

// The legacy camelCase vocabulary. `mapRoleToAppRole` in `utils/roles.js`
// translates the backend's canonical snake_case into these, and the route
// switch in `AppContentNew.jsx` matches on them, so a value missing here can
// never be routed. Keep the two in step.
export const roles = {
  loanOfficer: 'loanOfficer',
  consumer: 'consumer',
  organization: 'organization',
  superAdmin: 'superAdmin',
  branchAdmin: 'branchAdmin',
  loanProcessor: 'loanProcessor',
  underwriter: 'underwriter',
  closer: 'closer',
  auditor: 'auditor',
  // `read_only` used to map to `consumer`, which meant a read-only employee
  // was indistinguishable from a borrower. It has its own value now. It still
  // has no case in the route switch, so it still cannot reach the app -- but
  // it fails to the login screen rather than into the borrower product.
  readOnly: 'readOnly',
};
